import config, { TTenantConfigKey } from '@/dataroom/app/config/config';
import DataroomTenantConfig from '@/dataroom/app/config/DataroomTenantConfig';
import { IDataroomTenantConfig } from '@/dataroom/domain/vo/DataroomTenantConfig';

export const getDataroomTenantConfigs = () => (
  Object.keys(config.tenant) as TTenantConfigKey[]
).reduce<IDataroomTenantConfig[]>(
  (acc, key) => {
    let tenantConfig = DataroomTenantConfig.fromObject(config.tenant[key]);
    if (tenantConfig.options.isDataroom) {
      acc.push(tenantConfig);
    }
    return acc;
  },
  [],
);
